import styled from 'styled-components'

export const PageWrapper = styled.section`
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.primary};
`

export const FormWrapper = styled.div`
  width: 40rem;
  max-width: 70vw;

  form {
    width: 100%;
  }
`

export const ClaimWrapper = styled.div`
  width: 50rem;
  max-width: 70vw;
  padding-bottom: 2rem;
`

export const Terms = styled.ol`
  margin-bottom: 2.5rem;
`

export const CheckboxTerms = styled.ul`
  list-style: none;
  
  li {
    margin-bottom: 1rem;

    div {
      display: flex;
      align-content: center;

      strong {
        margin-left: 1rem;
      }
    }
  }
`

export const ActionsWrapper = styled.div`
  display: flex;
  margin-bottom: 2.5rem;
  flex-direction: column;
  align-items: flex-end;
`

export const AcceptTermMessage = styled.p`
  color: ${({ theme }) => theme.error};
`

export const NoPermissionStyles = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 20rem;

  p {
    padding: 0 1.5rem;
    text-align: center;
  }
`

export const FormPageWrapper = styled.section`
  width: 100%;
  display: flex;
  min-height: 100vh;
  padding-top: 5.8rem;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/Containers/Styles.js